import styled from 'styled-components';

export { default as NotLogin } from './not-login';
export { default as Login } from './login';

export const User = styled.div``;
